<template>
  <div class="doc-edit-container">
    <!-- 顶部工具栏 -->
    <div class="edit-toolbar">
      <div class="toolbar-left">
        <!-- <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/doc' }">文档首页</el-breadcrumb-item>
          <el-breadcrumb-item>{{ isEditMode ? '编辑文档' : '新建文档' }}</el-breadcrumb-item>
        </el-breadcrumb> -->
      </div>
      
      <div class="toolbar-right">
        <el-button size="small" @click="handleCancel">
          <i class="el-icon-close"></i> 取消
        </el-button>
        <el-button type="primary" size="small" :loading="saving" @click="handleSave">
          <i class="el-icon-check"></i> {{ saving ? '保存中...' : '保存' }}
        </el-button>
      </div>
    </div>
    
    <!-- 编辑器主体 -->
    <div class="edit-main">
      <!-- 文档信息区 -->
      <div class="doc-info-panel">
        <el-form :model="document" label-width="80px" size="small">
          <div class="form-row">
            <el-form-item label="文档标题" class="title-item">
              <el-input
                v-model="document.title"
                placeholder="请输入文档标题"
                maxlength="100"
                show-word-limit
                clearable
              ></el-input>
            </el-form-item>
            
            <el-form-item label="排序" class="order-item">
              <el-input-number 
                v-model="document.order" 
                :min="0" 
                :max="9999" 
                controls-position="right"
                placeholder="数字越小越靠前"
              ></el-input-number>
              <!-- <span class="form-tip">数字越小越靠前</span> -->
            </el-form-item>
          </div>
          
          <el-form-item label="关键词" class="keywords-item">
            <div class="keywords-tags">
              <el-tag
                v-for="(tag, index) in keywordTags"
                :key="index"
                closable
                :disable-transitions="false"
                @close="handleTagClose(index)"
                class="keyword-tag"
              >
                {{ tag }}
              </el-tag>
              <el-input
                v-if="inputVisible"
                v-model="inputValue"
                ref="saveTagInput"
                size="small"
                class="input-new-tag"
                @keyup.enter.native="handleInputConfirm"
                @blur="handleInputConfirm"
                placeholder="按回车添加"
              >
              </el-input>
              <el-button
                v-else
                class="button-new-tag"
                size="small"
                @click="showInput"
              >
                <i class="el-icon-plus"></i> 添加关键词
              </el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
      
      <!-- 编辑器区域 -->
      <div class="editor-wrapper">
        <quill-editor
          ref="editor"
          v-model="document.content"
          :options="editorOption"
          class="doc-editor"
          @click.native="handleEditorClick"
        />
      </div>
    </div>
    
    <!-- 图片预览 -->
    <el-image-viewer
      v-if="showImageViewer"
      :on-close="closeImageViewer"
      :url-list="previewImages"
      :initial-index="currentImageIndex"
    />
  </div>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import { quillEditor } from 'vue-quill-editor'
import { DOCUMENT_PATHS } from '@/api/paths'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'

export default {
  name: 'DocEdit',
  components: {
    quillEditor,
    ElImageViewer
  },
  data() {
    return {
      document: {
        title: '',
        content: '',
        categoryId: null,
        collectionId: null,
        order: 0,
        keywords: ''
      },
      saving: false,
      isEditMode: false,
      documentId: null,
      collectionId: null,
      showImageViewer: false,
      previewImages: [],
      currentImageIndex: 0,
      keywordTags: [],
      inputVisible: false,
      inputValue: '',
      hasUnsavedChanges: false,  // 标记是否有未保存的修改
      originalContent: '',  // 保存原始内容用于对比
      editorOption: {
        modules: {
          toolbar: [
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'color': [] }, { 'background': [] }],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            [{ 'align': [] }],
            [{ 'indent': '-1' }, { 'indent': '+1' }],
            ['blockquote', 'code-block'],
            ['link', 'image', 'video'],
            ['clean']
          ],
          clipboard: {
            matchVisual: false
          }
        },
        placeholder: '',
        theme: 'snow'
      }
    }
  },
  watch: {
    // 监听文档内容变化
    'document.content': {
      handler(newVal) {
        if (this.originalContent && newVal !== this.originalContent) {
          this.hasUnsavedChanges = true
        }
      },
      deep: true
    },
    // 监听标题变化
    'document.title': {
      handler(newVal, oldVal) {
        if (oldVal !== undefined && oldVal !== '' && newVal !== oldVal) {
          this.hasUnsavedChanges = true
        }
      }
    },
    // 监听关键词标签变化
    keywordTags: {
      handler() {
        if (this.originalContent) {
          this.hasUnsavedChanges = true
        }
      },
      deep: true
    }
  },
  
  beforeRouteLeave(to, from, next) {
    // 如果有未保存的修改，弹出确认对话框
    if (this.hasUnsavedChanges) {
      this.$confirm('您有未保存的修改，是否保存后再离开？', '提示', {
        confirmButtonText: '保存并离开',
        cancelButtonText: '不保存',
        distinguishCancelAndClose: true,
        type: 'warning'
      }).then(() => {
        // 保存并离开
        this.doSave().then(() => {
          this.hasUnsavedChanges = false
          next()
        }).catch(() => {
          next(false)
        })
      }).catch((action) => {
        if (action === 'cancel') {
          // 不保存，直接离开
          this.hasUnsavedChanges = false
          next()
        } else {
          // 取消离开
          next(false)
        }
      })
    } else {
      next()
    }
  },
  
  mounted() {
    // 从路由参数中获取文集ID和文档ID
    this.collectionId = this.$route.params.id
    this.documentId = this.$route.params.docId
    this.isEditMode = !!this.documentId
    
    // 设置文集ID到文档对象
    this.document.collectionId = this.collectionId ? parseInt(this.collectionId) : null
    
    // 监听浏览器关闭/刷新事件
    window.addEventListener('beforeunload', this.handleBeforeUnload)
    
    // 从URL获取categoryId（必填）
    const urlCategoryId = this.$route.query.categoryId
    if (urlCategoryId) {
      this.document.categoryId = parseInt(urlCategoryId)
    } else if (!this.isEditMode) {
      // 新建文档时，如果没有categoryId，提示并返回
      this.$message.warning('请从目录中创建文档')
      this.handleCancel()
      return
    }
    
    // 设置自定义图片上传处理器
    this.$nextTick(() => {
      if (this.$refs.editor && this.$refs.editor.quill) {
        const quill = this.$refs.editor.quill
        const toolbar = quill.getModule('toolbar')
        toolbar.addHandler('image', this.imageHandler)
      }
    })
    
    if (this.isEditMode) {
      this.loadDocument()
    } else {
      // 新建模式：初始化原始内容为空，以便监听生效
      this.originalContent = ''
      this.hasUnsavedChanges = false
    }
  },
  
  beforeDestroy() {
    // 移除浏览器关闭/刷新事件监听
    window.removeEventListener('beforeunload', this.handleBeforeUnload)
  },
  
  methods: {
    // 处理浏览器关闭/刷新事件
    handleBeforeUnload(e) {
      if (this.hasUnsavedChanges) {
        // 标准做法：设置returnValue并返回字符串
        e.preventDefault()
        e.returnValue = '您有未保存的修改，确定要离开吗？'
        return '您有未保存的修改，确定要离开吗？'
      }
    },
    
    async loadDocument() {
      try {
        const response = await this.$get(DOCUMENT_PATHS.GET_DOCUMENT + '?documentId=' + this.documentId)
        if (response.data && response.data.code === 200) {
          const data = response.data.data
          this.document.title = data.document.title
          this.document.content = data.document.content || ''
          this.document.categoryId = data.document.categoryId
          this.document.order = data.document.order || 0
          this.document.keywords = data.document.keywords || ''
          
          // 将路径格式转换为标签数组
          this.keywordTags = this.pathToTags(this.document.keywords)
          
          // 保存原始内容用于对比
          this.originalContent = this.document.content
          // 加载后重置未保存标记
          this.hasUnsavedChanges = false
        }
      } catch (error) {
        this.$message.error('加载文档失败')
        console.error(error)
      }
    },
    
    async imageHandler() {
      // 自定义图片上传处理 - 上传到OSS
      const input = document.createElement('input')
      input.setAttribute('type', 'file')
      input.setAttribute('accept', 'image/*')
      
      input.onchange = async () => {
        const file = input.files[0]
        if (!file) return
        
        // 验证文件类型
        if (!file.type.startsWith('image/')) {
          this.$message.error('只能上传图片文件')
          return
        }
        
        // 验证文件大小（5MB）
        if (file.size > 5 * 1024 * 1024) {
          this.$message.error('图片大小不能超过5MB')
          return
        }
        
        // 显示加载动画
        const loading = this.$loading({
          lock: true,
          text: '图片上传中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        
        try {
          // 创建FormData上传到OSS
          const formData = new FormData()
          formData.append('file', file)
          
          // 不要手动设置Content-Type，让浏览器自动设置（会自动添加boundary）
          const response = await this.$post('/upload/image', formData)
          
          if (response.data && response.data.code === 200) {
            const imageUrl = response.data.data.url
            
            // 插入图片到编辑器
            const quill = this.$refs.editor.quill
            const range = quill.getSelection()
            const index = range ? range.index : quill.getLength()
            quill.insertEmbed(index, 'image', imageUrl)
            
            // 移动光标到图片后面
            quill.setSelection(index + 1)
            
            this.$message.success('图片上传成功')
          } else {
            this.$message.error(response.data.msg || '图片上传失败')
          }
        } catch (error) {
          console.error('图片上传失败:', error)
          this.$message.error('图片上传失败：' + error.message)
        } finally {
          loading.close()
        }
      }
      
      input.click()
    },
    
    async handleSave() {
      if (!this.document.title) {
        this.$message.warning('请输入文档标题')
        return
      }
      
      if (!this.document.content || this.document.content.trim() === '<p><br></p>') {
        this.$confirm('文档内容为空，确定要保存吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.doSave()
        }).catch(() => {})
        return
      }
      
      this.doSave()
    },
    
    async doSave() {
      this.saving = true
      try {
        // 将标签数组转换为路径格式
        const keywordsPath = this.tagsToPath(this.keywordTags)
        
        const params = {
          title: this.document.title,
          content: this.document.content || '',
          categoryId: this.document.categoryId || null,
          collectionId: this.document.collectionId || null,
          order: this.document.order || 0,
          keywords: keywordsPath
        }
        
        let response
        if (this.isEditMode) {
          params.documentId = this.documentId
          response = await this.$post(DOCUMENT_PATHS.UPDATE_DOCUMENT, params)
        } else {
          response = await this.$post(DOCUMENT_PATHS.CREATE_DOCUMENT, params)
        }
        
        if (response.data && response.data.code === 200) {
          this.$message.success(this.isEditMode ? '保存成功' : '创建成功')
          
          // 保存成功后更新原始内容和重置未保存标记
          this.originalContent = this.document.content
          this.hasUnsavedChanges = false
          
          // 通知父组件刷新目录树（如果有）
          this.$emit('refresh')
          
          // 判断当前在admin后台还是普通用户文集系统
          const isAdmin = this.$route.path.startsWith('/admin')
          
          // 跳转到文档查看页（使用新的文集路由格式）
          if (this.isEditMode) {
            if (isAdmin) {
              this.$router.push(`/admin/collections/${this.collectionId}/doc/${this.documentId}`)
            } else {
              this.$router.push(`/collections/${this.collectionId}/doc/${this.documentId}`)
            }
          } else {
            const newDocId = response.data.data.documentId
            if (isAdmin) {
              this.$router.push(`/admin/collections/${this.collectionId}/doc/${newDocId}`)
            } else {
              this.$router.push(`/collections/${this.collectionId}/doc/${newDocId}`)
            }
          }
        }
      } catch (error) {
        this.$message.error(this.isEditMode ? '保存失败' : '创建失败')
        console.error(error)
      } finally {
        this.saving = false
      }
    },
    
    handleCancel() {
      if (this.document.title || (this.document.content && this.document.content !== '<p><br></p>')) {
        this.$confirm('确定要取消编辑吗？未保存的内容将丢失。', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '继续编辑',
          type: 'warning'
        }).then(() => {
          // 用户确认取消，重置未保存标记，避免路由守卫再次提示
          this.hasUnsavedChanges = false
          this.$router.back()
        }).catch(() => {})
      } else {
        // 没有内容，直接返回，也重置标记
        this.hasUnsavedChanges = false
        this.$router.back()
      }
    },
    
    // 处理编辑器点击事件
    handleEditorClick(event) {
      // 检查点击的是否是图片
      if (event.target.tagName === 'IMG') {
        const clickedImg = event.target
        const allImages = this.$el.querySelectorAll('.doc-editor img')
        
        // 获取所有图片的URL
        this.previewImages = Array.from(allImages).map(img => img.src)
        
        // 找到被点击图片的索引
        this.currentImageIndex = Array.from(allImages).indexOf(clickedImg)
        
        // 显示图片预览
        this.showImageViewer = true
      }
    },
    
    // 关闭图片预览
    closeImageViewer() {
      this.showImageViewer = false
    },
    
    // 将路径格式转换为标签数组
    pathToTags(path) {
      if (!path || path.trim() === '') {
        return []
      }
      // 移除首尾的斜杠，然后按斜杠分割
      return path.replace(/^\/+|\/+$/g, '')
        .split('/')
        .filter(tag => tag.trim() !== '')
    },
    
    // 将标签数组转换为路径格式
    tagsToPath(tags) {
      if (!tags || tags.length === 0) {
        return ''
      }
      return '/' + tags.join('/')
    },
    
    // 删除标签
    handleTagClose(index) {
      this.keywordTags.splice(index, 1)
    },
    
    // 显示输入框
    showInput() {
      this.inputVisible = true
      this.$nextTick(() => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },
    
    // 确认添加标签
    handleInputConfirm() {
      const inputValue = this.inputValue.trim()
      if (inputValue) {
        // 检查是否已存在
        if (this.keywordTags.includes(inputValue)) {
          this.$message.warning('该关键词已存在')
        } else {
          this.keywordTags.push(inputValue)
        }
      }
      this.inputVisible = false
      this.inputValue = ''
    }
  }
}
</script>

<style scoped>
.doc-edit-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #f5f7f9;
}

/* ===== 顶部工具栏 ===== */
.edit-toolbar {
  height: 50px;
  background: #fff;
  border-bottom: 1px solid #e4e7ed;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
}

.toolbar-left {
  flex: 1;
}

.toolbar-right {
  display: flex;
  gap: 10px;
}

/* ===== 编辑器主体 ===== */
.edit-main {
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  padding: 20px;
}

/* ===== 文档信息区 ===== */
.doc-info-panel {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.08);
}

.doc-info-panel .form-row {
  display: flex;
  gap: 20px;
  align-items: flex-start;
}

.doc-info-panel .title-item {
  flex: 1;
  margin-bottom: 0;
}

.doc-info-panel .order-item {
  width: 280px;
  margin-bottom: 0;
}

.doc-info-panel .keywords-item {
  width: 100%;
}

.doc-info-panel ::v-deep .el-form-item {
  margin-bottom: 15px;
}

.doc-info-panel ::v-deep .el-form-item:last-child {
  margin-bottom: 0;
}

.form-tip-block {
  margin-top: 8px;
  padding: 8px 12px;
  background: #f4f4f5;
  border-radius: 4px;
  font-size: 12px;
  color: #909399;
  display: flex;
  align-items: center;
  gap: 6px;
}

.form-tip-block i {
  color: #409EFF;
  font-size: 14px;
}

/* ===== 关键词标签 ===== */
.keywords-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}

.keyword-tag {
  height: 32px;
  line-height: 30px;
}

.input-new-tag {
  width: 120px;
}

.button-new-tag {
  height: 32px;
  line-height: 30px;
  padding: 0 15px;
}

/* ===== 编辑器区域 ===== */
.editor-wrapper {
  flex: 1;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0,0,0,0.08);
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.doc-editor {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.doc-editor ::v-deep .ql-toolbar {
  border: none;
  border-bottom: 1px solid #e4e7ed;
  background: #fafafa;
  padding: 12px 16px;
  flex-shrink: 0;
}

.doc-editor ::v-deep .ql-container {
  flex: 1;
  border: none;
  font-size: 16px;
  overflow-y: auto !important;
  min-height: 0;
}

.doc-editor ::v-deep .ql-editor {
  min-height: 500px;
  padding: 30px 40px;
  line-height: 1.8;
}

.doc-editor ::v-deep .ql-editor > * {
  max-width: 80%;
  /* margin-left: auto; */
  /* margin-right: auto; */
}

.doc-editor ::v-deep .ql-editor.ql-blank::before {
  color: #c0c4cc;
  font-style: normal;
}

/* ===== Quill工具栏美化 ===== */
.doc-editor ::v-deep .ql-toolbar .ql-stroke {
  stroke: #606266;
}

.doc-editor ::v-deep .ql-toolbar .ql-fill {
  fill: #606266;
}

.doc-editor ::v-deep .ql-toolbar button:hover .ql-stroke,
.doc-editor ::v-deep .ql-toolbar button.ql-active .ql-stroke {
  stroke: #409EFF;
}

.doc-editor ::v-deep .ql-toolbar button:hover .ql-fill,
.doc-editor ::v-deep .ql-toolbar button.ql-active .ql-fill {
  fill: #409EFF;
}

.doc-editor ::v-deep .ql-toolbar button:hover,
.doc-editor ::v-deep .ql-toolbar button.ql-active {
  background: #ecf5ff;
  border-radius: 4px;
}

/* ===== 编辑器内容样式 ===== */
.doc-editor ::v-deep .ql-editor h1 {
  font-size: 28px;
  font-weight: 600;
  margin: 20px 0 14px;
  color: #303133;
  border-bottom: 2px solid #e4e7ed;
  padding-bottom: 10px;
}

.doc-editor ::v-deep .ql-editor h2 {
  font-size: 24px;
  font-weight: 600;
  margin: 18px 0 12px;
  color: #303133;
  padding-left: 12px;
  border-left: 4px solid #409EFF;
}

.doc-editor ::v-deep .ql-editor h3 {
  font-size: 20px;
  font-weight: 600;
  margin: 16px 0 10px;
  color: #303133;
}

.doc-editor ::v-deep .ql-editor h4,
.doc-editor ::v-deep .ql-editor h5,
.doc-editor ::v-deep .ql-editor h6 {
  font-size: 18px;
  font-weight: 600;
  margin: 14px 0 8px;
  color: #303133;
}

.doc-editor ::v-deep .ql-editor p {
  margin: 10px 0;
}

.doc-editor ::v-deep .ql-editor img {
  max-width: 100%;
  width: auto;
  height: auto;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  margin: 16px 0;
  display: block;
  object-fit: contain;
}

.doc-editor ::v-deep .ql-editor blockquote {
  border-left: 4px solid #409EFF;
  background: #ecf5ff;
  padding: 12px 16px;
  margin: 16px 0;
  border-radius: 4px;
}

.doc-editor ::v-deep .ql-editor pre {
  background: #282c34;
  color: #abb2bf;
  padding: 16px;
  border-radius: 6px;
  margin: 16px 0;
  word-wrap: break-word;
  word-break: break-all;
  white-space: pre-wrap;
  overflow-x: auto;
  max-width: 100%;
}

.doc-editor ::v-deep .ql-editor code {
  background: #f5f7f9;
  padding: 3px 8px;
  border-radius: 4px;
  font-family: 'Consolas', 'Monaco', 'Courier New', monospace;
  font-size: 14px;
  color: #e96900;
}

.doc-editor ::v-deep .ql-editor pre.ql-syntax {
  background: #282c34;
  color: #abb2bf;
}

/* ===== 滚动条 ===== */
.doc-editor ::v-deep .ql-editor::-webkit-scrollbar {
  width: 8px;
}

.doc-editor ::v-deep .ql-editor::-webkit-scrollbar-thumb {
  background: #d1dbe5;
  border-radius: 4px;
}

.doc-editor ::v-deep .ql-editor::-webkit-scrollbar-track {
  background: #f5f7f9;
}

/* ===== 表单提示 ===== */
.form-tip {
  margin-left: 10px;
  font-size: 12px;
  color: #909399;
}

/* ===== 响应式 ===== */
@media (max-width: 768px) {
  .edit-toolbar {
    padding: 0 15px;
    height: 45px;
  }
  
  .edit-main {
    padding: 10px;
  }
  
  .doc-info-panel {
    padding: 15px;
    margin-bottom: 15px;
  }
  
  .doc-info-panel .form-row {
    flex-direction: column;
    gap: 15px;
  }
  
  .doc-info-panel .order-item {
    width: 100%;
  }
  
  .editor-wrapper {
    border-radius: 4px;
  }
  
  .doc-editor ::v-deep .ql-toolbar {
    padding: 10px 12px;
    flex-wrap: wrap;
  }
  
  .doc-editor ::v-deep .ql-editor {
    padding: 20px 16px;
    min-height: 400px;
  }
  
  .doc-editor ::v-deep .ql-editor > * {
    max-width: 100%;
  }
}

@media (max-width: 480px) {
  .edit-toolbar {
    padding: 0 10px;
    height: 40px;
  }
  
  .toolbar-right {
    gap: 5px;
  }
  
  .edit-main {
    padding: 8px;
  }
  
  .doc-info-panel {
    padding: 12px;
  }
  
  .doc-editor ::v-deep .ql-toolbar {
    padding: 8px;
  }
  
  .doc-editor ::v-deep .ql-toolbar button {
    padding: 6px;
  }
  
  .doc-editor ::v-deep .ql-editor {
    padding: 15px 12px;
    min-height: 300px;
    font-size: 14px;
  }
}
</style>
